import { connect } from 'react-redux';
import { lifecycle, compose } from 'recompose';

import { getBarbers } from '../actions/brand';
import BarbersList from './BarbersList';
import { getAll } from '../selector';
import { getActiveBrandId } from '../../../auth/selectors';
import withLoadingList from '../../../common/hoc/withLoaingList';
import EmptyList from './EmptyList';

const mapStateToProps = state => ({
  barbers: getAll(state),
  brandId: getActiveBrandId(state),
  isBrandView: true,
  isSortable: false,
});

const mapDispatchToProps = {
  fetchBarbers: getBarbers,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      this.props.fetchBarbers(this.props.brandId);
    },
  }),
  withLoadingList(
    props => props.barbers,
    EmptyList,
  )
)(BarbersList);
